interface Options {
  onError: (error: Error) => void;
}

export default function registerSW(url: string, { onError }: Options) {
  global.navigator.serviceWorker
    .register(url)
    .then(registration => {
      // eslint-disable-next-line no-param-reassign
      registration.onupdatefound = function onUpdateFound() {
        const installingWorker = registration.installing;
        if (!installingWorker) {
          return;
        }
        // tslint:disable no-console
        installingWorker.onstatechange = function onStateChange() {
          if (installingWorker.state === 'installed') {
            if (global.navigator.serviceWorker.controller) {
              console.info('New or updated content is available.');
            } else {
              console.info('Content is now available offline!');
            }
          } else if (installingWorker.state === 'redundant') {
            console.error('The installing service worker became redundant.');
          }
        };
        // tslint:enable no-console
      };
    })
    .catch(onError);
}
